<template>
  <div class="w-full mb-5   lg:w-1/5">
    <vx-card class="">
      <template slot="no-body">
        <div class="w-full flex lg:flex-col justify-between md:p-5">
          <vs-button
            @click="toggleCreate(true)"
            class="mb-3 hidden lg:flex"
            color="primary"
            type="filled"
            icon="icon-edit"
            icon-pack="feather"
            v-if="navigations.action.hidden !== true"
            >{{ navigations.action.buttonTitle }}</vs-button
          >

          <vs-button
            @click="toggleCreate(true)"
            v-if="navigations.action.hidden !== true"
            radius
            size="large"
            class="mb-3 lg:hidden  fab-sidebar shadow-md z-20"
            color="primary"
            type="filled"
            icon="icon-plus"
            icon-pack="feather"
          ></vs-button>
          <AppNavbarItem
            v-for="(item, index) in navigations.list"
            :key="index"
            :item="item"
            :active="navigationActive"
          />
          <AppNavbarDropdown
            class="lg:hidden"
            :navigations="navigationsDropdown"
          />
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import AppNavbarItem from "./AppNavbarItem.vue";
import AppNavbarDropdown from "./AppNavbarDropdown.vue";

export default {
  components: {
    AppNavbarItem,
    AppNavbarDropdown
  },

  props: {
    maxShowMobile: {
      type: Number,
      default: 4
    }
  },

  computed: {
    ...mapState({
      navigations: state => state.globalApp.navigations
    }),
    ...mapGetters({
      navigationsDropdown: "globalApp/fetchNavigationsDropdown",
      navigationActive: "globalApp/fetchNavigationActive",
      navigationAction: "globalApp/fetchNavigationAction"
    })
  },

  methods: {
    toggleCreate(bol) {
      if (this.navigations.action.to)
        this.$router.push({ path: this.navigations.action.to });
      else this.$store.dispatch("globalApp/toggleCreate", bol);
    }
  }
};
</script>

<style lang="scss">
.fab-sidebar {
  position: fixed;
  bottom: 20px;
  right: 20px;
  font-size: 2rem !important;
}

.includeIconOnly.large {
  width: 70px !important;
  height: 70px !important;
}

.vs-button.large .vs-button--icon {
  font-size: 2.5rem !important;
}
</style>
